import React, { useState } from 'react';

import { X } from 'react-feather';

import {
   DE_SHUTDOWN_DATE_TEXT,
   EMPLOYER_PORTAL_TRANSITION_URL,
} from 'constants/deprecation';

const DISMISS_STORAGE_KEY = 'deDeprecationBannerDismissed';

// Rendered as a fixed bar at the bottom of the viewport: the DE pages'
// .fixedHeaderLayout title/filter block is position:fixed with z-index 99
// and overlays anything placed at the top of the content flow.
const styles = {
   bar: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1030,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '0.5rem 1.25rem',
      padding: '0.75rem 1.5rem',
      background: '#34302a',
      borderTop: '3px solid #ee9e07',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.25)',
      color: '#fff',
   },
   title: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
   },
   message: {
      color: 'rgba(255, 255, 255, 0.85)',
   },
   dismiss: {
      marginLeft: 'auto',
      background: 'transparent',
      border: 'none',
      padding: '0.25rem',
      color: 'rgba(255, 255, 255, 0.85)',
      cursor: 'pointer',
      lineHeight: 0,
   },
};

const getIsDismissed = () => {
   try {
      return window.sessionStorage.getItem(DISMISS_STORAGE_KEY) === 'true';
   } catch (e) {
      return false;
   }
};

const DirectEmployerDeprecationBanner = () => {
   const [isDismissed, setIsDismissed] = useState(getIsDismissed);

   const handleDismiss = () => {
      try {
         window.sessionStorage.setItem(DISMISS_STORAGE_KEY, 'true');
      } catch (e) {
         // storage unavailable — dismiss for this render only
      }
      setIsDismissed(true);
   };

   if (isDismissed) {
      return null;
   }

   return (
      <div style={ styles.bar } role='alert'>
         <span style={ styles.title }>
            Direct Employer is retiring on
            {' '}
            { DE_SHUTDOWN_DATE_TEXT }
         </span>
         <span style={ styles.message }>
            This portal is moving to the new Jobcase Employer portal —
            please use it for your hiring going forward.
         </span>
         <a
            href={ EMPLOYER_PORTAL_TRANSITION_URL }
            target='_blank'
            rel='noopener noreferrer'
            className='btn btn-rounded btn-dark-orange btn-sm'
         >
            Go to the new Employer portal
         </a>
         <button
            type='button'
            style={ styles.dismiss }
            onClick={ handleDismiss }
            aria-label='Dismiss'
         >
            <X size={ 18 }/>
         </button>
      </div>
   );
};

export default DirectEmployerDeprecationBanner;
